export enum LimitEvaluationEnum { MAX, MIN };

export interface LimitControlDeleteRequest {
  id: string;
}

export interface Denominator {
  id: string;
  name: string;
}

export interface LimitType {
  id: string;
  name: string;
}

export interface Portfolio {
  id: string;
  name: string;
  nit: string;
  dv: number;
  decevalAccount: number;
  DCVAccount: number;
}

export interface SubLimitType {
  id: string;
  limitTypeId: string;
  name: string;
}

export interface LimitControlEntity {
  id: string;
  limitType: LimitType;
  limitEvaluation: LimitEvaluationEnum;
  percentage: number;
  subLimit: SubLimitType;
  denominator: Denominator;
  portfolio: Portfolio;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface LimitControlEntityKV {
  id: string;
  limitType: string;
  limitEvaluation: string;
  percentage: number;
  subLimit: string;
  denominator: string;
  portfolio: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface ResponseLimitTypes {
  success: boolean;
  data?: LimitType[];
  error?: string;
  message?: string;
}

export interface ResponsePortfolio {
  success: boolean;
  data?: Portfolio[];
  error?: string;
  message?: string;
}
export interface ResponseDenominators {
  success: boolean;
  data?: Denominator[];
  error?: string;
  message?: string;
}

export interface ResponseSubLimitTypes {
  success: boolean;
  data?: SubLimitType[];
  error?: string;
  message?: string;
}

export interface ResponseLimitControl {
  success: boolean;
  data?: LimitControlEntity[];
  error?: string;
  message?: string;
}

export interface ResponseLimitControlKV {
  success: boolean;
  data?: LimitControlEntityKV[];
  error?: string;
  message?: string;
}

export interface LimitControlCreateRequest {
  limitType: string;
  limitEvaluation: string;
  percentage: number;
  subLimit: string;
  denominator: string;
  portfolio: string;
}

export interface LimitControlUpdateRequest {
  id: string;
  limitType: string;
  limitEvaluation: string;
  percentage: number;
  subLimit: string;
  denominator: string;
  portfolio: string;
}